<template>
  <v-dialog
    v-model="canShow"
    :transition="false"
    @keydown.esc="closeDialog"
    @click:outside="closeDialog"
  >
    <v-card
      class="card"
      elevation="0"
      style="max-height: 70vh; display: flex; flex-direction: column;"
    >
      <v-card-title
        class="card-title"
      >
        {{ $t('road-maintenance/aggregator.shape_your_polyline') }}

        <v-spacer />

        <universal-button
          type="base"
          :ripple="false"
          :elevation="0"
          class="no-background-hover"
          style="border: unset !important; color: #6B7280;"
          append-icon="mdi-close"
          @click="closeDialog"
        />
      </v-card-title>
      <v-card-text
        class="card-text"
        style="overflow-y: auto; flex-grow: 1;"
      >
        <v-row>
          <v-col>
            Što je polilinija bliža geometriji ceste, veća je vjerojatnost da će je Waze ispravno uskladiti i obraditi zatvaranje.
            Preporučuje se navođenje više točaka za svaki segment između početne i krajnje koordinate. Navođenje samo 2 koordinate može biti dovoljno za kratke ili ravne segmente, ali je često uzrok neuspjeha obrade.
            Sljedeća polilinija ispravno održava opći oblik ceste:
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-img
              src="/img/correct-road-polyline.png"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            Sljedeća polilinija ne odražava jasno geometriju ceste jer pruža samo početne i završne koordinate:
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-img
              src="/img/incorrect-road-polyline.png"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            Koristit ćemo poliliniju koju ste naveli za primjenu događaja na jedan ili više segmenata na Waze karti. Imajte na umu da primijenjeno zatvaranje može biti dulje ili nešto kraće od polilinije, budući da Waze može zatvoriti samo cijele segmente kako je konfigurirano na kartama.
            Ako odredite samo dio segmenta za zatvaranje, cijeli segment će biti zatvoren.
            Preporučuje se da početna i krajnja točka zatvaranja budu udaljene najmanje 30 metara.
            Duljina navedene polilinije ne smije prelaziti 20 km.
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import UniversalButton from '@/global/components/buttons/UniversalButton.vue'

export default {
  name: 'MapInfo',

  components: {
    UniversalButton
  },

  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      canShow: false
    }
  },

  watch: {
    showDialog: {
      immediate: true,
      handler (val) {
        this.canShow = !!val
      }
    }
  },

  methods: {
    closeDialog () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.card-title {
  font-family: 'Satoshi', sans-serif !important;
  color: #111827;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  border-bottom: 1px solid #E5E7EB;
}

.card {
  width: 800px;
  background-color: #FFFFFF !important;
  margin: 0;
  padding: 0;
}

.card-text {
  font-family: 'Satoshi', sans-serif !important;
  color: #52525B;
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  padding: 24px 40px 40px 40px;
}

::v-deep {
  .v-dialog {
    width: unset !important;
    border-radius: 16px !important;
  }
}
</style>
